

define(['jquery', 'angular', 'squid/index'], function ($, angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-login.capeUtil', ['squid']).factory('$capeRedirectUtil', function ($util, $CreditDataModel, $state) {
        return {
            handleCapeRouting: function handleCapeRouting(checkoutSession, checkoutCart, token) {
                var fundingInstruments = void 0,
                    isCreditInWallet = void 0;

                if (checkoutCart.isBillingNoPurchase()) {
                    fundingInstruments = checkoutSession.futurePaymentInstruments;
                    isCreditInWallet = checkoutSession.futurePayment && checkoutSession.futurePayment.isCreditInWallet;
                } else {
                    fundingInstruments = checkoutSession.fundingOptions && checkoutSession.fundingOptions.instruments;
                    isCreditInWallet = fundingInstruments && $util.find(fundingInstruments, function (fi) {
                        return fi.name === 'BILL_ME_LATER';
                    });
                }

                var creditDataModel = $CreditDataModel.instance(token);
                var isCapeReturnKey = creditDataModel.getCapeKey();
                var isCapeReturn = isCapeReturnKey && $util.param('success');
                var isPPCEligible = checkoutSession.creditOffer || checkoutSession.bmlOffer;

                // User does not have any FI in wallet but they choose to pay in full.
                // Show add card contingency page instead of redirecting to CAPE.

                if (checkoutSession.isCreditPromoted && !fundingInstruments && creditDataModel.payInFull || !fundingInstruments && !isPPCEligible) {

                    return $state.go('checkout.pageAddCard.addCardFlow.addCard');
                }

                // Handle case where it was timeout and status is to go back to cape
                else if (isCreditInWallet || isCapeReturn || creditDataModel.payInFull) {
                        return $state.go('checkout.review');
                    }

                    // Handle "checkout with paypal" link on cyco
                    else if (!isCreditInWallet && isPPCEligible) {
                            return $state.go('checkout.redirectToCape');
                        } else {
                            // show error message
                            return $state.go('checkout.review');
                        }
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-login/util.js
// module id = ./pages/xo-login/util.js
// module chunks = 1